export default __webpack_public_path__ + "static/bin-80a6bae3700ade3c4a6b45174cee68af.svg";